import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetAllRoundActive } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import { GetAllFieldsManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldsManager";
import { GetTransferFromEvaluator } from "../../../Redux/Reducers/Manager/Dropdowns/TransferFromEvaluator";
import { GetAllSubjectManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllSubjectManager";
import { GetTransferToEvaluator } from "../../../Redux/Reducers/Manager/Dropdowns/TransferToEvaluator";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";

function TransferBetweenEvaluatorDropDowns(props) {
  const dispatch = useDispatch();

  const [DropDownRoundActive, setDropDownRoundActive] = useState(null);
  const [DropDownFields, setDropDownFields] = useState(null);
  const [DropDownSubject, setDropDownSubject] = useState(null);
  const [DropDownFrom, setDropDownFrom] = useState(null);

  const [DropDownTo, setDropDownTo] = useState(null);

  const state = useSelector((state) => {
    return {
      DropDownRoundActive: state.AllRoundActive.AllRoundActive,
      DropDownFromEvaluator: state.TransferFromEvaluator.TransferFromEvaluator,
      DropDownToEvaluator: state.TransferToEvaluator.TransferToEvaluator,
      DropDownFieldsManager: state.AllFieldsManager.AllFieldsManager,
      DropDownSubjectManager: state.AllSubjectManager.AllSubjectManager,
    };
  });
  console.log(state.DropDownFromEvaluator);

  useEffect(() => {
    dispatch(GetAllRoundActive());
  }, [dispatch]);

  useEffect(() => {
    if (DropDownRoundActive) {
      dispatch(
        GetAllFieldsManager({ roundYearId: parseInt(DropDownRoundActive) })
      );
    }
  }, [DropDownRoundActive, dispatch]);

  useEffect(() => {
    if (DropDownFields) {
      dispatch(GetAllSubjectManager({ fieldId: DropDownFields }));
    }
  }, [DropDownFields, dispatch]);

  useEffect(() => {
    if (DropDownRoundActive && DropDownFields && DropDownSubject) {
      dispatch(
        GetTransferFromEvaluator({
          roundId: parseInt(DropDownRoundActive),
          fieldId: DropDownFields,
          subjectId: DropDownSubject,
        })
      );
    }
  }, [DropDownRoundActive, DropDownFields, DropDownSubject]);

  useEffect(() => {
    if (DropDownFrom) {
      dispatch(
        GetTransferToEvaluator({
          roundId: parseInt(DropDownRoundActive),
          userId: DropDownFrom,
          fieldId: DropDownFields,
          subjectId: DropDownSubject,
        })
      );
    }
  }, [DropDownFrom, DropDownFields, DropDownSubject]);

  return (
    <>
      <div className="form-grid">
        <AllDropDownsAHSF
          fieldsName="Round"
          lang="ar"
          show={true}
          arrayOoptionList={state.DropDownRoundActive}
          KeyText={"roundNameAr"}
          KeyValue={"roundYearId"}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownRoundActive(e.target.value);
            props.setRoundActive(e.target.value);
            dispatch(SetArrayDataCheckBoks());
            setDropDownFields(null);
          }}
        />
        <AllDropDownsAHSF
          fieldsName="field"
          lang="ar"
          show={true}
          arrayOoptionList={state.DropDownFieldsManager}
          KeyText={"fieldNameAr"}
          KeyValue={"fieldId"}
          dropdownType={"normal"}
          value={DropDownFields}
          onChange={(e) => {
            setDropDownFields(e.target.value);
            props.setFields(e.target.value);
            props.setDropDownFrom(null);
            props.setDropDownTo(null);
            dispatch(SetArrayDataCheckBoks());
            setDropDownSubject(null);
          }}
        />
        <AllDropDownsAHSF
          fieldsName="topic"
          lang="ar"
          show={true}
          arrayOoptionList={state.DropDownSubjectManager}
          KeyText={"subjectNameAr"}
          KeyValue={"subjectId"}
          value={DropDownSubject}
          dropdownType={"normal"}
          onChange={(e) => {
            setDropDownSubject(e.target.value);
            props.setSubject(e.target.value);
            props.setDropDownFrom(null);
            props.setDropDownTo(null);
            dispatch(SetArrayDataCheckBoks());
             setDropDownFrom(null)
          }}
        />
        <AllDropDownsAHSF
          // clear={true}
          fieldsName="TransferFromEvaluator"
          show={true}
          lang="ar"
          arrayOoptionList={state.DropDownFromEvaluator}
          defaultValue={props.DropDownFrom}
          KeyText={"userFullName"}
          KeyValue={"userId"}
          dropdownType={"normal"}
          value={DropDownFrom}
          onChange={(e) => {
            setDropDownFrom(e.target.value);
            props.setDropDownFrom(e.target.value);
            props.setDropDownTo(null);
            dispatch(SetArrayDataCheckBoks());
             setDropDownTo(null)
          }}
        />
        <AllDropDownsAHSF
          fieldsName="TransferToEvaluator"
          lang="ar"
          show={true}
          arrayOoptionList={state.DropDownToEvaluator}
          defaultValue={props.DropDownTo}
          KeyText={"userFullName"}
          KeyValue={"userId"}
          dropdownType={"normal"}
          value={DropDownTo}
          onChange={(e) => {
            setDropDownTo(e.target.value);
            props.setDropDownTo(e.target.value);
           
          }}
        />
      </div>
    </>
  );
}

export default TransferBetweenEvaluatorDropDowns;
